/**
 * Check and return true if an object not undefined or null
 */
export function isPresent(obj) {
    return obj !== undefined && obj !== null;
}



//////////////////
// WEBPACK FOOTER
// ./~/ng2-slim-loading-bar/src/slim-loading-bar.utils.js
// module id = 348
// module chunks = 0